<template>
  <div class="news-wrap container" v-if="list.length > 0">
    <div class="news_top flex flex_content_sb flex_items_center">
      <titleConfig
        :title="langSet == 'cn' ? '新闻资讯' : 'News Center'"
        :type="1"
      ></titleConfig>
      <div
        class="btn-slide btn-slide-right small-btn flex_content_center flex_items_center"
        @click="toMore"
      >
        <div class="btn-main">
          {{ langSet == "cn" ? "查看更多" : "View More"
          }}<span class="icon"></span>
        </div>
      </div>
    </div>
    <div class="news_list flex flex_wrap">
      <news
        class="news_item_wrap"
        :type="1"
        v-for="(item, index) in list"
        :key="index"
        :newsData="item"
      ></news>
    </div>
  </div>
</template>
<script>
import titleConfig from "@/components/title.vue";
import news from "@/components/news.vue";
import { articleList } from "@/api/api";
import { sdkClick } from "../../../sdk/useSdk";
export default {
  components: {
    titleConfig,
    news,
  },
  data() {
    return {
      langSet: "",
      list: [],
    };
  },
  mounted() {
    this.langSet = this.$language;
    //25.9.24 获取新闻资讯 dxm
    this.getList();
  },
  methods: {
    async getList() {
      let data = {
        page_no: 1,
        page_size: 4,
        lang: this.langSet,
      };
      const res = await articleList(data);
      this.list = res.data.lists;
    },
    toMore() {
      sdkClick("首页功能区", "新闻中心");
      this.$router.push({
        path: "/news",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.news-wrap {
  margin-bottom: 120px;
  .news_top {
    margin-bottom: 30px;
  }
  .news_item_wrap {
    width: calc((100% - 120px) / 4);
    margin-right: 40px;
    &:nth-child(4) {
      margin-right: 0;
    }
  }
}
@media only screen and (max-width: 1280px) {
  .news-wrap {
    .news_item_wrap {
      width: calc((100% - 60px) / 4);
      margin-right: 20px;
    }
  }
}
@media only screen and (max-width: 767px) {
  .news-wrap {
    position: relative;
    padding-bottom: 1rem;
    margin-bottom: 0;
    .news_item_wrap {
      width: 100%;
      margin-right: 0;
      margin-bottom: 0.38rem;
    }
    .news_top {
      margin-bottom: 0.38rem;
      .news_more {
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 3.04rem;
        height: 0.69rem;
        font-size: 0.27rem;
        transform: translateX(-50%);
      }
    }
  }
}
</style>